/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import TwoColumns from '../components/layouts/TwoColumns';
import {ColumnContainer, PersonSection} from '../components/layouts/TwoColumns';
import AmandaFox from '../assets/images/amandafox.png';
import Ellen from '../assets/images/ellenAccelerator.png';
import Eirik from '../assets/images/eirik.png';
import Eskild from '../assets/images/eskild.png';
import AcceleratorHeader from '../components/layouts/AcceleratorHeader';
import {CenteredContainer} from '../components/styled/CenteredContainer';
import {Cuributton} from '../components/_atoms/Cuributton';
import AcceleratorVideoCarousel from '../components/_molecules/AcceleratorVideoCarousel';
import CuriousCuriLogoForButton from '../assets/icons/CuriosCuriLogoForButton';
import {IconWrapper} from '../components/_atoms/IconWrapper';
import Image from 'next/image';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  customHeader: _jsx(AcceleratorHeader, {
    page: 'accelerator'
  }),
  disableHeadline: true,
  mdx: true,
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      blockquote: "blockquote"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "The AI Accelerator program"
      }), "\n", _jsx(_components.p, {
        children: "Artificial intelligence is transforming society and education, and the Curipod AI accelerator program is your opportunity to take the lead! The Curipod AI accelerator program - batch 2, is designed to help a few selected schools and districts accelerate their competence within AI and become a leader within the space, providing the best education supported by artificial intelligence.\nThe program will be run by the Curipod team. They have built the leading educational AI tool used all over the world and guarantee real change!"
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsx(_components.p, {
          children: "“It speaks to the quality of the program that multiple teachers were able to introduce Curipod in their classroom the day after the first session”"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsx(_components.p, {
          children: "“I loved their pedagogical approach of thinking about instruction first and technology second”"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(AcceleratorVideoCarousel, {}), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
